module.exports = __webpack_public_path__ + "static/img/open_price_tips.9f40e31c.png";